import React from "react";
import styles from "./GameControls.module.css";
import BettingControls from "../BettingControls/BettingControls";
import ProfitDisplay from "../ProfitDisplay/ProfitDisplay";
import ActionButton from "../ActionButton/ActionButton";
import { duringAutoPlay, beforePlay } from "../../redux/types/userModeTypes";
import {
  changeBetAmount,
  changeMinesAmount,
  changeOnWinPercentage,
  changeOnLossPercentage,
} from "../../redux/slices/gameSettingsSlice";
import { changeUserMode } from "../../redux/slices/userModeSlice";
import { useSelector, useDispatch } from "react-redux";
import useStartGame from "../../utils/useStartGame";
import useCashOut from "../../utils/useCashOut";
import SwitchModeButton from "../SwitchModeButton/SwitchModeButton";
import MineAndGemControls from "../MineControls/MineControls";
import MineAndGemShow from "../MineAndGemShow/MineAndGemShow";
import AutoBetsNumberOfRounds from "../AutoBetsNumberOfRounds/AutoBetsNumberOfRounds";
import OnWinOrLossInAuto from "../OnWinOrLossInAuto/OnWinOrLossInAuto";
import AutoBetsStopLossOrWin from "../AutoBetsStopLossOrWin/AutoBetsStopLossOrWin";
import {
  changeIsInManualMode,
  changeAutoBetsNumberOfRounds,
  changeOnWinStopValue,
  changeOnLossStopValue,
} from "../../redux/slices/gameSettingsSlice";
import clickAudio from "../../audios/click.mp3";
import useSound from "use-sound";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";
import useAuto from "../../utils/useAuto";
import WinsAndLossesShow from "../WinsAndLossesShow/WinsAndLossesShow";
const GameControls = () => {
  const sounds = useSelector((state) => state.sounds);
  const userMode = useSelector((state) => state.userMode);
  const user = useSelector((state) => state.user);
  const gameSettings = useSelector((state) => state.gameSettings);
  const gameData = useSelector((state) => state.gameData);
  const dispatch = useDispatch();
  const startGame = useStartGame();
  const startAuto = useAuto();
  const cashOut = useCashOut();

  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const clickSound = () => {
    playClickSound();
  };
  const changeGameMode = () => {
    dispatch(changeIsInManualMode());
  };
  return (
    <div className={styles.gameControls}>
      <div className={styles.balanceContainer}>
        <div>
          Balance:{" "}
          <span className={styles.bold}>{user.balance.toFixed(1)}</span>
        </div>
        <SwitchModeButton
          isDisable={userMode.userModeState !== beforePlay}
          handleChange={changeGameMode}
          isChecked={gameSettings.isInManualMode}
        />
        <BettingControls
          isChangeable={userMode.userModeState === beforePlay}
          value={gameSettings.betAmount}
          onChange={(val) => {
            dispatch(changeBetAmount(val));
          }}
        />{" "}
      </div>
      {userMode.userModeState === beforePlay ? (
        <div className={styles.wrapper}>
          <MineAndGemControls
            value={gameSettings.minesAmount}
            onChange={(val) => {
              dispatch(changeMinesAmount(val));
            }}
          />
          {!gameSettings.isInManualMode ? (
            <AutoBetsNumberOfRounds
              value={gameSettings.autoBetsNumberOfRounds}
              isChangeable={true}
              onChange={(val) => {
                dispatch(changeAutoBetsNumberOfRounds(val));
              }}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <OnWinOrLossInAuto
              value={gameSettings.onWinPercentage}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnWinPercentage(val));
              }}
              isOnWin={true}
              isResetProp={gameSettings.isOnWinReset}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <OnWinOrLossInAuto
              value={gameSettings.onLossPercentage}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnLossPercentage(val));
              }}
              isOnWin={false}
              isResetProp={gameSettings.isOnLossReset}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <AutoBetsStopLossOrWin
              value={gameSettings.onWinStopValue}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnWinStopValue(val));
              }}
              isOnWin={true}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <AutoBetsStopLossOrWin
              value={gameSettings.onLossStopValue}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnLossStopValue(val));
              }}
              isOnWin={false}
            />
          ) : (
            <></>
          )}
          <ActionButton
            text={gameSettings.isInManualMode ? "Bet" : "Start"}
            onClick={() => {
              clickSound();
              if (gameSettings.isInManualMode) {
                startGame(gameSettings.betAmount, gameSettings.minesAmount);
              } else {
                dispatch(changeUserMode(duringAutoPlay));
                startAuto();
              }
            }}
            isDisable={
              !gameSettings.isInManualMode &&
              gameSettings.selectedTiles.length < 1
            }
          />
        </div>
      ) : (
        <div className={styles.wrapper}>
          <MineAndGemShow value={gameSettings.minesAmount} />
          {!gameSettings.isInManualMode ? <WinsAndLossesShow /> : <></>}
          <ProfitDisplay />
          {!gameSettings.isInManualMode ? (
            <AutoBetsNumberOfRounds
              value={gameSettings.autoBetsCurrentNumberOfRounds}
              isChangeable={false}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <OnWinOrLossInAuto
              value={gameSettings.onWinPercentage}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnWinPercentage(val));
              }}
              isOnWin={true}
              isResetProp={gameSettings.isOnWinReset}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <OnWinOrLossInAuto
              value={gameSettings.onLossPercentage}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnLossPercentage(val));
              }}
              isOnWin={false}
              isResetProp={gameSettings.isOnLossReset}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <AutoBetsStopLossOrWin
              value={gameSettings.onWinStopValue}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnWinStopValue(val));
              }}
              isOnWin={true}
            />
          ) : (
            <></>
          )}
          {!gameSettings.isInManualMode ? (
            <AutoBetsStopLossOrWin
              value={gameSettings.onLossStopValue}
              isChangeable={userMode.userModeState === beforePlay}
              onChange={(val) => {
                dispatch(changeOnLossStopValue(val));
              }}
              isOnWin={false}
            />
          ) : (
            <></>
          )}
          {/* <PickRandomTileActionButton
            text="Pick random tile"
            onClick={() => {}}
          /> */}
          {!gameSettings.isInManualMode &&
          userMode.userModeState === duringAutoPlay ? (
            <ActionButton
              text="Stop"
              onClick={() => {
                dispatch(changeUserMode(beforePlay));
              }}
            />
          ) : (
            <ActionButton
              isDisable={gameData.openedIndexes.length === 0}
              text="Cashout"
              onClick={() => {
                cashOut();
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default GameControls;
